module.exports = __webpack_public_path__ + "img/05.0b16bd55.jpg";